export * from './core/index';
//# sourceMappingURL=core.js.map


//////////////////
// WEBPACK FOOTER
// ./~/md2/core.js
// module id = 60
// module chunks = 3